export class DizionarioSearchModel{
    public codice:string
}


// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/models/shared/dizionarioSearch.model.ts